import { Grid, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import PageInfoTitle from "../../components/pageTitle/PageInfoTitle";
import StorageTab from "../components/storage/components/StorageTab";
import StorageLeadList from "../components/storage/components/StorageLeadList";
import StorageLeadCardDetails from "../components/storage/components/StorageLeadCardDetails";
import StorageLeadFormDetails from "../components/storage/components/StorageLeadFormDetails";
import StorageManageSection from "../components/storage/components/StorageManageSection";
import StorageLogList from "../components/storage/components/StorageLogList";
import { getStorageLeadDetail } from "../components/storage/storageStaticData";
import { useDispatch, useSelector } from "react-redux";
import { getSingleStorageAction } from "../../store/reducers/storageSlice";
import ContractList from "../components/storage/components/contracts/ContractList";

const ClientAdminStorage = () => {
  const [generateId, setGenerateId] = useState<string | null>(null);
  const dispatch = useDispatch();
  const {storageDetails} = useSelector((state:any)=> state.storage);
  // Derive details from static data based on selected id
  const leadDetails = getStorageLeadDetail(generateId);

  useEffect(() => {
    if (generateId) {
      dispatch(
        getSingleStorageAction({
          storageId: generateId,
        }),
      );
    }
  }, [generateId]);

  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={{ xs: 1, sm: 1, md: 1 }}
      sx={{ background: "#f4f4f4" }}
    >
      {/* ─── LEFT PANEL: Lead List ─── */}
      <Grid item xs={12} md={3}>
        <Box sx={{ height: { xs: "auto", md: "100vh" } }}>
          <StorageLeadList setGenerateId={setGenerateId} />
        </Box>
      </Grid>

      {/* ─── RIGHT PANEL: Details ─── */}
      <Grid item xs={12} md={9}>
        <Container
          maxWidth="lg"
          sx={{
            paddingLeft: "0px !important",
            paddingRight: "0px !important",
          }}
        >
          <Box
            sx={{
              height: { xs: "auto", md: "100vh" },
              paddingLeft: "0px !important",
              paddingRight: "0px !important",
              overflow: "scroll",
            }}
          >
            {/* ─── Sticky Header ─── */}
            <Box
              sx={{
                position: "sticky",
                top: 0,
                bgcolor: "#fff",
                zIndex: 1,
                border: "1px solid #C4CDD5",
              }}
            >
              <PageInfoTitle
                title=""
                desc={
                  storageDetails?.lead_id
                    ? `Ref No. ${storageDetails?.lead_id}`
                    : ""
                }
                leadId={storageDetails?.lead_id}
                isPrint={false}
                isEmail={false}
                isText={false}
                disabled1={!storageDetails?.lead_id}
                disabled={true}
              />
              <StorageTab leadDetails={storageDetails} />
            </Box>

            {/* ─── Card Details ─── */}
            <StorageLeadCardDetails leadDetails={storageDetails} />

            {/* ─── Form Details ─── */}
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                overflow: "hidden",
                padding: "10px 0px !important",
              }}
            >
              {storageDetails && storageDetails?.lead_id ? (
                <StorageLeadFormDetails leadDetails={storageDetails} />
              ) : (
                <center>
                  <Typography sx={{ color: "#4A4A4A" }}>
                    No Record Found!
                  </Typography>
                </center>
              )}
            </Box>

            {/* ─── Manage Lead Section ─── */}
            <Box
              sx={{
                bgcolor: "#fff",
                height: { xs: "auto" },
                border: "1px solid #d1cfcf",
                borderRadius: "5px",
                marginTop: "10px",
                padding: "0px 10px 10px 10px !important",
              }}
            >
              <Typography
                sx={{
                  textTransform: "capitalize !important",
                  padding: "10px 0px",
                  fontWeight: 800,
                  color: "#333333",
                  fontSize: "16px",
                }}
                variant="subtitle1"
              >
                Manage Lead
              </Typography>
              <ContractList generateId={generateId}/>
              {/* <StorageManageSection generatedId={generateId} /> */}
            </Box>

            {/* ─── Logs Section ─── */}
            {storageDetails?.lead_id && (
              <Box
                sx={{
                  bgcolor: "#fff",
                  height: { xs: "auto" },
                  border: "1px solid #d1cfcf",
                  borderRadius: "5px",
                  marginTop: "10px",
                  padding: "10px !important",
                }}
              >
                <Typography
                  sx={{
                    textTransform: "capitalize !important",
                    padding: "0px",
                    fontWeight: 800,
                    color: "#333333",
                    fontSize: "16px",
                  }}
                  variant="subtitle1"
                >
                  Logs
                </Typography>
                <StorageLogList leadId={generateId} />
              </Box>
            )}
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default ClientAdminStorage;
